import "./StyleKpiElement.css"

function KpiGrid({name, value, is_percents, zone}) {

    function ColorZone (zone){
        if (zone === "green"){
            return "green--value"
        }else if(zone === "yellow"){
            return "orange--value"
        }else{
            return "red--value"
        }
    }

    function setValue(value__, is_percents__) {
        if (is_percents__) {
            return (value__ * 100).toFixed(1) + "%";
        } else {
            const num = parseFloat(value__);
            return num === Math.floor(num) ? num.toString() : num.toString().replace(/\.?0+$/, '');
        }
    }

    return (
        <>
            <div className="kpi--container--block">
                <div className="kpi--container-nameIndicators">
                    <span>{name}</span>
                </div>
                <span className={is_percents ? ColorZone(zone) : ""} id="kpi--container-indicators">{value === null ? "Нет" : setValue(value, is_percents)}</span>
            </div>
        </>
    )
}

export default KpiGrid;
